export default {
  getAlerts: {
    server: '/projects/{projectId}/alerts',
    method: 'get',
  },
  updateAlertStatus: {
    server: '/projects/{projectId}/alerts/{alertId}/status',
    method: 'patch',
  },
};
